<template lang="pug">
	div
		div.menuAgenda.bg-dark.text-white
			ul
				li(:class="(seccion === 'listados') ? 'active' : ''", @click="go('listados')")
					span.fa.fa-list.mb-1(style="font-size:1.5em;")
					br
					| Agenda
				li(:class="(seccion === 'calendario') ? 'active' : ''", @click="go('calendario')")
					span.fa.fa-calendar.mb-1(style="font-size:1.5em;")
					br
					| Calendario
				li(:class="(seccion === 'propuestas') ? 'active' : ''", @click="go('propuestas')")
					span.fa.fa-money.mb-1(style="font-size:1.5em;")
					br
					| Propuestas
				li(:class="(seccion === 'estadisticas') ? 'active' : ''", @click="go('estadisticas')")
					span.fa.fa-bar-chart.mb-1(style="font-size:1.5em;")
					br
					| Estadísticas
		router-view(style="margin-top:60px;")
</template>

<script>
export default {
	data () {
		return {
			seccion: null
		}
	},

	created () {
		// this.go('listados')
	},

	methods: {
		go (seccion) {
			this.$router.push('/main/agenda-comercial/' + seccion)
			this.seccion = seccion
		}
	}
}
</script>


<style scoped>
	.menuAgenda {
		position: absolute;
		display: block;
		top: 0;
		left: 0;
		right: 0;
		overflow-x: auto;
	}
	.menuAgenda > ul {
		position: relative;
		display: table;
		margin: 0;
		padding: 0;
		/*width: 100%;*/
	}

	.menuAgenda > ul > li {
		position: relative;
		display: table-cell;
		text-align: center;
		height: 50px;
		padding: 15px;
		vertical-align: middle;
		cursor: pointer;
	}

	.menuAgenda > ul > li:hover {
		background-color: #777777;
	}

	.menuAgenda > ul > li.active {
		background-color: #f3f3f3;
		color: #444444;
	}
</style>


// WEBPACK FOOTER //
// src/modulos/agenda-comercial/vue/app.vue